
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
// eslint-disable-next-line
import { Validation } from 'vuelidate' //Don't remove this import, otherwise validations isnt recognized
import Axios from 'axios'
import { BASE_URL, ANTIFORGERY_INPUT_NAME } from '../helpers/constants'
import { FIRSTNAME_FIELD, LASTNAME_FIELD, EMAIL_FIELD, ORGANISATION_FIELD, FUNCTION_FIELD, CONSENT_FIELD, INTERESTS_FIELD } from '../helpers/form-constants'
import { getValidations, scrollToElement, setNecessaryFormFields } from '../helpers/functions'
import { IFormField } from '../types/forms'
import FormField from './form-field.vue'

@Component({
  validations() {
    return getValidations((this as NewsletterForm).formFields)
  },
  components: { FormField }
})
export default class NewsletterForm extends Vue {
  @Prop() subscribeNewsletterPopupTitle: string
  @Prop() subscribeNewsletterPopupText: string
  @Prop() subscribeNewsletterPopupButtonText: string
  @Prop() subscribeNewsletterSuccessMessage: string
  @Prop() subscribeNewsletterErrorMessage: string
  @Prop() overviewShowMoreButtonText: string

  formFields: IFormField[] = [
    FIRSTNAME_FIELD,
    LASTNAME_FIELD,
    EMAIL_FIELD,
    ORGANISATION_FIELD,
    FUNCTION_FIELD,
    { ...INTERESTS_FIELD, options: window.TRANSLATIONS.subscribeNewsletterInterests },
    { ...CONSENT_FIELD, labelTranslateKey: 'subscribeNewsletterConsentLabel' }
  ]

  model: { [key in string]: any } = {}

  loading = false

  isSent = false

  async send(): Promise<void> {
    this.$v.$touch()
    if (this.$v.$invalid) {
      this.$nextTick(() => scrollToElement(this.$el, '.error'))
      return
    }

    this.loading = true

    try {
      const antiForgeryInput: HTMLInputElement | null = document.querySelector(`input[name=${ANTIFORGERY_INPUT_NAME}]`)
      this.model[ANTIFORGERY_INPUT_NAME] = antiForgeryInput?.value

      const res: { data: { success: boolean } } = await Axios.post(`${BASE_URL}/newsletter/subscribe`, this.model)
      if (res.data.success) {
        this.isSent = true
      } else throw new Error()

    } catch (error) {
      console.error(error)
      this.$store.commit('notifications/add', { message: this.subscribeNewsletterErrorMessage })
    } finally {
      this.loading = false
    }
  }

  created(): void {
    setNecessaryFormFields(this, this.formFields)
  }
}
